/* eslint-disable multiline-ternary */
/* eslint-disable react/react-in-jsx-scope */

// 路由拦截器
function PrivateRoute (props: { children: React.ReactNode }): JSX.Element {
  const { children } = props;
  return <>{children}</>;
};

export default PrivateRoute;
